import React from "react";
import { useRouter } from "next/router";
import { Button as AntButton, Result } from "antd";
import Meta from "../Meta";
import Loader from "../loader";
import Paiement from "../../../components/paiement";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { loadPaiementConfig } from "../../../services/paiementLauncher";

class PaiementPage extends React.Component {
    state = { config: null };

    componentDidMount() {
        const { router } = this.props;
        const context = this.props.context;
        const { org } = context;

        if (context.page.config) {
            this.setState({ config: context.page.config });
        } else {
            try {
                // Pas de config lisible (panier trop volumineux pour l'URL, stockage
                // de session cloisonné par site hôte, valeur corrompue) :
                // `loadPaiementConfig` renvoie null sans lever, donc le catch
                // ci-dessous ne peut plus jouer. Sans ce repli, le donateur
                // resterait devant une page vide.
                const config = loadPaiementConfig(org);
                if (config) {
                    this.setState({ config });
                } else if (typeof window !== "undefined") {
                    window.location.href = org.BASE_WEB_URL;
                } else {
                    router.replace(org.BASE_WEB_URL);
                }
            } catch (e) {
                if (typeof window !== "undefined") {
                    window.location.href = org.BASE_WEB_URL;
                } else {
                    router.replace(org.BASE_WEB_URL);
                }
            }
        }
    }

    render() {
        const context = this.props.context;
        const { org } = context;
        let title = t`Paiement - ${org.name}`;
        let description = t`Paiement à ${org.name}`;

        if (this.state.config?.update) {
            const name = this.state.config.paiement?.name || "";
            title = description = `${t`Modification`} - ${name}`;
        }

        if (this.props.loading) {
            return (
                <>
                    <Meta context={context} title={title} description={description} />
                    <Loader />
                </>
            );
        }

        if (this.state.config?.update && this.state.config?.paiement?.finalized) {
            return (
                <>
                    <Meta context={context} title={title} description={description} />
                    <div style={{ minHeight: "40vh", display: "flex", justifyContent: "center", alignItems: "center", padding: 20 }}>
                        <Result
                            style={{ maxWidth: 600 }}
                            status="warning"
                            title={t`Ce lien est expiré !`}
                            subTitle={t`Pour toute question contactez directement votre responsable.`}
                            extra={context.render !== "embed" ? (
                                <AntButton href={org.BASE_WEB_URL}><Trans>Retourner à la page d'accueil</Trans></AntButton>
                            ) : undefined}
                        />
                    </div>
                </>
            );
        }

        return (
            <>
                <Meta context={context} title={title} description={description} />
                <div style={{ marginTop: 20, padding: "0 clamp(16px, 4vw, 32px)" }}>
                    {this.state.config && <Paiement context={context} config={this.state.config} travel={context.travel} />}
                </div>
            </>
        );
    }
}

export default function PaiementWrapper(props) {
    const router = useRouter();
    return <PaiementPage router={router} {...props} />;
}
